import React from 'react';
import { Clock, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface OppmoteEmptyStateProps {
  readOnly: boolean;
  onAdd: () => void;
}

export const OppmoteEmptyState: React.FC<OppmoteEmptyStateProps> = ({
  readOnly,
  onAdd,
}) => {
  return (
    <div className="text-center py-12 bg-muted rounded-md">
      <Clock className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
      <p className="text-muted-foreground">Ingen oppmøtetider registrert</p>
      {!readOnly && (
        <Button onClick={onAdd} variant="outline" size="sm" className="mt-4">
          <Plus className="h-4 w-4 mr-2" />
          Legg til første oppmøtetid
        </Button>
      )}
    </div>
  );
};

